import { FC } from 'react';
import { useLocale } from 'next-intl';

type Props = {
  arabicName: string;
  englishName: string;
};
const CurrentLanguageText: FC<Props> = ({ arabicName, englishName }) => {
  const lang = useLocale();
  const isArabic = lang === 'ar';
  return isArabic ? arabicName : englishName;
};

export default CurrentLanguageText;
